<template>
  <span class="blue-1" style="font-family: monospace; font-size: 16px;" >{{ REQUEST_NO }}</span>
</template>

<script>
export default {
  name:"SpanServiceNo",
  setup(props) {
    let REQUEST_NO = props.params.data.REQUEST_NO;
    let FSYSTEM_DT_TEXT = props.params.data.FSYSTEM_DT_Text;

    return { REQUEST_NO, FSYSTEM_DT_TEXT };
  },
};
</script>

<style>
</style>